import { render } from "./new-construction.vue?vue&type=template&id=ea4e1418"
import script from "./new-construction.vue?vue&type=script&lang=js"
export * from "./new-construction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__